<script>
    import {workouts} from './calendarWorkouts.js'
    import {getFirstDayOfTheWeek, getLastDayOfTheWeek, searchDateFromArray, plusDate, formatDate} from './utils.js'
    import {onMount} from "svelte";

    const firstDayOfTheCurrentWeek = getFirstDayOfTheWeek(new Date());

    export let plusDays = 0;
    export let week = 1;

    //console.log("plusDays", plusDays, "week", week);
    //console.log("firstDayOfTheCurrentWeek" , firstDayOfTheCurrentWeek);
    //console.log ("plusDate(firstDayOfTheCurrentWeek, plusDays)", plusDate(firstDayOfTheCurrentWeek, plusDays));
    //console.log("löytyylk ", searchFromArray(plusDate(firstDayOfTheCurrentWeek, plusDays), workouts));
    //console.log("formatdate", formatDate(plusDate(firstDayOfTheCurrentWeek, plusDays)));

    let sresult;
    let formattedDate;
    let workoutCount = 0;
    let weekday = ["Maanantai", "Tiistai", "Keskiviikko", "Torstai", "Perjantai", "Lauantai", "Sunnuntai"];

    function dayname(week, daynumber) {
        daynumber = daynumber;

        if (week == 1) {
            return weekday[daynumber];
        }
        if (week == 2) {
            return weekday[daynumber - 7];
        }
    }

    onMount(async () => {
        formattedDate = formatDate(plusDate(firstDayOfTheCurrentWeek, plusDays));
        sresult = searchDateFromArray(formattedDate, workouts);
        workoutCount = sresult.length;
    });

</script>
{#if 0 < workoutCount}
    <div class="col-xs-4">
        <div class="weekdayMobile">{dayname(week, plusDays)}
            <span style="font-weight: normal">{formattedDate}</span>
        </div>
        {#each searchDateFromArray(formattedDate, workouts) as t}
            <div class="mobile-workout col-xs-12">
                <span> - {t.start} </span>
                <span class="mobile-type-{t.type}">{t.name} </span>
            </div>
        {/each}
    </div>
{/if}

<style>
    .mobile-workout {
        font-weight: bold;
        padding: 4px 4px 4px 24px;
    }

    .mobile-type-savotta {
        color: #5b5f51;
    }
    .mobile-type-pilates {
        color: #475373;
    }

    .mobile-type-kehonhuolto {
        color: #606675;
    }

    .mobile-type-kaski {
        color: #66695c;
    }

    .mobile-type-painonnosto {
        color: #5a574b;
    }
</style>
